import React from "react";

import Header from "../Header/Header";
import Roters from "../../router/Routers";
import Footer from "../Footer/Footer";

const Layout = () => {
  return (
    <>
      <Header />
      <Roters />
      <Footer />
    </>
  );
};

export default Layout;
